import { Text, TextInput, View } from "react-native";
import { styles } from "./styles";

interface PrinterInputProps {
  label: string;
  value: string;
  onChangeText: (text: string) => void;
  placeholder: string;
}

export const PrinterInput = ({
  label,
  value,
  onChangeText,
  placeholder,
}: PrinterInputProps) => {
  return (
    <View style={{ width: "100%", gap: 10 }}>
      <Text style={styles.inputLabel}>{label}</Text>
      <TextInput
        value={value}
        onChangeText={onChangeText}
        placeholder={placeholder}
        style={styles.input}
      />
    </View>
  );
};
